import * as moment from 'moment';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../../i18n';

@Pipe({
  name: 'daysUntilDue',
  pure: true
})
export class DaysUntilDuePipe implements PipeTransform {
  constructor(
    private translate: TranslateService
  ) {}

  transform(nextBusinessDay: string, dueDate: string) {
    if (!nextBusinessDay || !dueDate) {
      return '';
    }

    const today = moment().format('YYYY-MM-DD');
    const daysUntilDue = Math.ceil(moment(dueDate).diff(moment(), 'days', true));
    const diffNBD = Math.ceil(moment((<any>nextBusinessDay || today)).diff(moment(dueDate), 'days', true));

    const pastNextBusinessDay = diffNBD > 0;
    const overdue = daysUntilDue < 0;

    let daysUntilDueMsg = '';
    let daysBehindNBDMsg = '';

    if (pastNextBusinessDay) {
      daysBehindNBDMsg = this.translate.instant(`DAYS_BEHIND_NBD`, `${Math.abs(diffNBD)}`);
    }

    if (overdue || pastNextBusinessDay) {
      daysUntilDueMsg = this.translate.instant('DAYS_PAST_DUE', `${Math.abs(Math.abs(daysUntilDue) > diffNBD ? daysUntilDue : diffNBD)}`);
    } else {
      daysUntilDueMsg = this.translate.instant('DAYS_UNTIL_DUE', `${Math.abs(daysUntilDue)}`);
    }

    return { 
      daysUntilDue,
      daysUntilDueMsg,
      daysBehindNBDMsg,
      diffNBD,
      pastNextBusinessDay,
      overdue
    };
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/days-until-due.pipe.ts